import { useMemo } from "react";

import { Theme } from "@mui/material/styles";

import { useMediaQuery } from "@/hooks/useMediaQuery";

export interface ThemedBackgroundShapeConfiguration {
  id: string;
  style: object;
  rotationMultiplier: number;
  scaleMultiplier: number;
}

export const useBackgroundShapesConfiguration = () => {
  const { isSmallScreen, value: isExtraLargeScreen } = useMediaQuery((theme: Theme) => theme.breakpoints.up("xl"));

  return useMemo<ThemedBackgroundShapeConfiguration[]>(() => {
    if (isSmallScreen) {
      return [
        {
          // Shape 1 - Top Left
          id: "mobileShape1",
          style: { top: "-64px", left: "-40px", width: "193px", height: "auto" },
          rotationMultiplier: 1.0,
          scaleMultiplier: 1.3,
        },
        {
          // Shape 2 - Bottom Right
          id: "mobileShape2",
          style: { bottom: "-16px", right: "-24px", width: "96px", height: "auto" },
          rotationMultiplier: 0.9,
          scaleMultiplier: 1.5,
        },
        {
          // Shape 3 - Top Right
          id: "mobileShape3",
          style: { top: "35%", right: "-108px", width: "186px", height: "auto" },
          rotationMultiplier: 1.1,
          scaleMultiplier: 0.8,
        },
        {
          // Shape 4 - Bottom Left
          id: "mobileShape4",
          style: { bottom: "64px", left: "-80px", width: "133px", height: "auto" },
          rotationMultiplier: 1.0,
          scaleMultiplier: 1.05,
        },
      ];
    }

    return [
      {
        // Shape 1 - Top Left
        id: "desktopShape1",
        style: {
          top: "-64px",
          left: "-80px",
          width: "258px",
          height: "auto",
        },
        rotationMultiplier: 1.0,
        scaleMultiplier: 1.1,
      },
      {
        // Shape 4 - Top Right
        id: "desktopShape2",
        style: {
          top: "-156px",
          right: "-72px",
          width: "340px",
          height: "auto",
        },
        rotationMultiplier: 1.05,
        scaleMultiplier: 1.05,
      },
      {
        // Shape 3 - Bottom Left
        id: "desktopShape3",
        style: {
          bottom: "40px",
          left: "-120px",
          width: "264px",
          height: "auto",
        },
        rotationMultiplier: 0.95,
        scaleMultiplier: 1.1,
      },
      {
        // Shape 2 - Bottom Right
        id: "desktopShape4",
        style: {
          bottom: isExtraLargeScreen ? "-113px" : "-123px",
          right: isExtraLargeScreen ? "-83px" : "-100px",
          width: "264px",
          height: "auto",
        },
        rotationMultiplier: 1.0,
        scaleMultiplier: 0.95,
      },
    ];
  }, [isSmallScreen, isExtraLargeScreen]);
};
